import {
  fetchBalanceDetail,
  fetchMyAccountDetails,
  getEquityAccPreferences,
  subscribeWhatsapp,
  updateEquityAccPreferences,
} from "../../apis/myAccount";
// import { addAdditionalBank } from '../reducers/myAccount';
import {
  fetchMyAccount,
  fetchEquityAccPreferences,
  setEquityAccPreferences,
  updateOrderPreferences,
  updateWhatsAppSubscription,
  setBalanceData,
  fetchBalance,
  resetAccountData,
  getEquitySubscriptionStatus,
  setEquitySubscriptionStatus,
} from "../reducers/myAccount";
import { get, noop } from "lodash-es";
import { put, call, takeLatest } from "redux-saga/effects";
import { getProcessedAccountData } from "../../utils/myAccount/functions";
import { resetError, setError } from "../reducers/error";
import { setAccountData, setBanksListMap } from "../reducers/myAccount";
import {
  setActionLoaderFalse,
  setActionLoaderTrue,
} from "../reducers/actionLoader";
import { fetch_equity_status_data } from "../../apis/common";
import { COMMON } from "../../strings/common";

function* handleFetchBalance({ payload }) {
  const { Api, screen, sagaCallback = noop } = payload;
  try {
    yield put(setActionLoaderTrue(fetchBalance));
    yield put(resetError({ screen }));
    const response = yield call(fetchBalanceDetail, Api);
    yield put(setBalanceData(response));
    yield call(sagaCallback, response);
  } catch (error) {
    yield put(
      setError({ screen, isFetchFailed: true, message: error.message })
    );
    console.log("balance", error.message);
  } finally {
    yield put(setActionLoaderFalse(fetchBalance));
  }
}

function* handleFetchMyAccount({ payload }) {
  const { Api, screen, sagaCallback = noop } = payload;
  try {
    yield put(setActionLoaderTrue(fetchMyAccount));
    yield put(resetError({ screen }));
    const response = yield call(fetchMyAccountDetails, Api);
    const { banksListMap } = yield call(getProcessedAccountData, response);
    yield put(setAccountData(response));
    yield put(setBanksListMap(banksListMap));
    yield call(sagaCallback, response);
  } catch (error) {
    yield put(
      setError({ screen, isFetchFailed: true, message: error.message })
    );
    console.log(error.message);
  } finally {
    yield put(setActionLoaderFalse(fetchMyAccount));
  }
}

function* handleUpdateWhatsAppSubscription({ payload }) {
  const { Api, screen, params, sagaCallback = noop } = payload;
  try {
    yield put(setActionLoaderTrue(updateWhatsAppSubscription));
    yield put(resetError({ screen }));
    const response = yield call(subscribeWhatsapp, Api, params);
    // Update AccountData with latest whatsapp details
    yield put(setAccountData({ whatsapp_contact: response.contact_details }));
    yield call(sagaCallback, response);
  } catch (error) {
    yield put(
      setError({ screen, isUpdateFailed: true, message: error.message })
    );
    console.log(error);
  } finally {
    yield put(setActionLoaderFalse(updateWhatsAppSubscription));
  }
}

function* handleFetchEquityAccPreferences({ payload }) {
  const { Api, screen, sagaCallback = noop } = payload;
  try {
    yield put(setActionLoaderTrue(fetchEquityAccPreferences));
    yield put(resetError({ screen }));
    const response = yield call(getEquityAccPreferences, Api);
    yield put(setEquityAccPreferences(response.preferences));
    yield call(sagaCallback, response);
  } catch (error) {
    yield put(
      setError({ screen, isFetchFailed: true, message: error.message })
    );
    console.log(error);
  } finally {
    yield put(setActionLoaderFalse(fetchEquityAccPreferences));
  }
}

function* handleUpdateOrderPreferences({ payload }) {
  const API_KEY = "order_preference";
  const actionName = updateOrderPreferences.toString();
  const { Api, screen, params, sagaCallback = noop } = payload;
  try {
    yield put(setActionLoaderTrue(actionName));
    yield put(resetError({ screen }));
    const response = yield call(
      updateEquityAccPreferences,
      Api,
      { preference_type: API_KEY },
      params
    );
    const formattedResponse = get(response, `file_info.${API_KEY}`, {});
    yield put(
      setEquityAccPreferences({
        [API_KEY]: formattedResponse,
      })
    );
    yield call(sagaCallback, formattedResponse, response);
  } catch (error) {
    yield put(
      setError({ screen, isUpdateFailed: true, message: error.message })
    );
    console.log(error);
  } finally {
    yield put(setActionLoaderFalse(actionName));
  }
}

function* handleFetchEquitySubscriptionStatus({ payload = {} }) {
	const { Api, screen = '', sagaCallback = noop } = payload;
	try {
		yield put(setActionLoaderTrue(getEquitySubscriptionStatus));
		yield put(setError({ screen, isFetchFailed: false, message: '' }));
		const response = yield call(fetch_equity_status_data, Api);
		const equitySubscriptionStatus = get(response, 'data.equity.subscription_status.data', {});
		yield put(setEquitySubscriptionStatus(equitySubscriptionStatus));
		yield call(sagaCallback, response);
	} catch (error) {
		console.log('error inside handleFetchEquitySubscriptionStatus is', error.message);
		if (error !== COMMON.ApiCancelled)
			yield put(setError({ screen, isFetchFailed: true, message: error.message }));
	} finally {
		yield put(setActionLoaderFalse(getEquitySubscriptionStatus));
	}
}

export default function* sagaFetchMyAccount() {
  yield takeLatest(fetchMyAccount, handleFetchMyAccount);
  yield takeLatest(fetchEquityAccPreferences, handleFetchEquityAccPreferences);
  yield takeLatest(
    updateWhatsAppSubscription,
    handleUpdateWhatsAppSubscription
  );
  yield takeLatest(updateOrderPreferences, handleUpdateOrderPreferences);
  // yield takeLatest(addAdditionalBank, handleAddAdditonalBank);
  yield takeLatest(fetchBalance, handleFetchBalance);
  yield takeLatest(getEquitySubscriptionStatus.toString(), handleFetchEquitySubscriptionStatus);
}
